module.exports = __webpack_public_path__ + "static/media/A1-10-Zenthos-cod92.b1b170c1.png";